import axios from "axios";
import { PATH } from "../../utils";

const api = axios.create({ baseURL: PATH, headers: { "Content-Type": "application/json" } });

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionCorreosGet = (categorias = []) => async () => {
  const params = new URLSearchParams();
  categorias.forEach((c) => params.append("categorias", c));
  const resp = await api.get(`correos?${params.toString()}`, { headers: authHeader() });
  return resp.data;
};

export const actionCorreoGetById = (id) => async () => {
  const resp = await api.get(`correos/${id}`, { headers: authHeader() });
  return resp.data;
};
